import { render } from "./NumberZeroField.vue?vue&type=template&id=487c3a82"
import script from "./NumberZeroField.vue?vue&type=script&lang=js"
export * from "./NumberZeroField.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__